import { useEffect, useState } from 'react';

/** Возвращает число секунд до окончания заданного срока */
export const useCountdown = (deadline: number | null): number => {
    const [now, setNow] = useState(Date.now);

    useEffect(() => {
        setNow(Date.now());

        if (deadline == null || deadline <= Date.now()) return;

        const timer = window.setInterval(() => {
            const currentTime = Date.now();
            setNow(currentTime);

            if (currentTime >= deadline) window.clearInterval(timer);
        }, 1000);

        return () => window.clearInterval(timer);
    }, [deadline]);

    return deadline == null
        ? 0
        : Math.max(0, Math.ceil((deadline - now) / 1000));
};
